import { create } from "zustand";
import { createCustomerSlice, CustomerUIState } from "./slice/customerSlice";
import { createProfileSlice, ProfileSlice } from "./slice/profileSlice";
import { createApplicationSlice, ApplicationSlice } from "./slice/applicationSlice";
import { createLoanSlice, LoanSlice } from "./slice/loanSlice";
import { createRiskScoreSlice, RiskScoreSlice } from "./slice/riskScoreSlice";
import { createKycSlice, KycSlice } from "./slice/kycSlice";
import { CashflowScoreSlice, createCashflowScoreSlice } from "./slice/cashflowScoreSlice";

type AppState = CustomerUIState & ProfileSlice & ApplicationSlice & LoanSlice & RiskScoreSlice & CashflowScoreSlice & KycSlice;

export const useAppStore = create<AppState>()((set) => ({
  ...createCustomerSlice(set),
  ...createProfileSlice(set),
  ...createApplicationSlice(set),
  ...createLoanSlice(set),
  ...createRiskScoreSlice(set),
  ...createCashflowScoreSlice(set),
  ...createKycSlice(set)
}));
